window._ = require('lodash');

// try {
//     require('bootstrap');
// } catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
// import { getLocaleFromURL } from './locale.js';

// window.axios.defaults.headers.common['Accept-Language'] = getLocaleFromURL();

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
// window.axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;

window.axios.interceptors.request.use((config) => {
    if(localStorage.getItem('token')){
        localStorage.setItem('token' , localStorage.getItem('token'))
        config.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    }
    return config;
});

// Response interceptor to handle "Unauthenticated" errors
axios.interceptors.response.use(response => {
    // If the response is successful, just return it
    return response;
}, error => {
    // Check if the response is an error with "Unauthenticated" message and status code 500
    if (error.response && error.response.data && error.response.data?.message === "Unauthenticated." && error.response?.status === 500) {
        // Redirect to login page
        // Assuming you have Vue Router available as $router, and it is in scope

        location.href = '/courses-login';

        // if (typeof $router !== 'undefined') {
        //     $router.push({ name: 'login' });
        // } else {
        //     console.error("Router is not available!");
        // }
    }
    // Return the Promise rejection with the error
    return Promise.reject(error);
});


axios.defaults.baseURL = '/api/';


// import { useToast } from "vue-toastification";
// const toast = useToast();
//
// // doing something with the response
// axios.interceptors.response.use(
//     (response) => {
//         // all 2xx/3xx responses will end here
//         // console.log(response);
//         return response;
//     },
//     (error) => {
//         // // all 4xx/5xx responses will end here
//         // console.log(error.response.data.errors);
//         // console.log(error.response.data);
//         // console.log(error.response.request);
//
// toast.error(error.response.data.message  ,{
//     timeout: 3000,
// },{ icon: 'fa-solid fa-circle-exclamation'  });
//         new $.Errors({
//             xml:{
//                 responseJSON : error.response.data
//             },
//         });
//
//         return Promise.reject(error);
//     }
// );


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

// import Echo from 'laravel-echo';
//
//
// window.Pusher = require('pusher-js');
//
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true,
//     auth: {
//         headers: {
//             Authorization: `Bearer ${localStorage.getItem('token')}`
//         },
//     },
// });
